const GlobalAuthenticatedContextModel: any = {
    user: {},
    organization: {},
    orgConfiguration: {},
    contextLoaded: false,
    installed: false,
    subscriptionValid: false,
    inGCloud: false,
    appFoundry: false,
    userRoles: [],
    integrationFound: true,
    usageLiscenseStatus: 'ACTIVE'
};

export default GlobalAuthenticatedContextModel;